'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useDormantSummary } from '@/routes/_staff/accesses/_layout/alerts/-dormancy-query';
import { useAlertsSummary, useShadowServices } from '@/routes/_staff/accesses/_layout/alerts/-query';
import { useActiveMemberCount, useOverviewShadowDetection } from './-api';
import { DormancyCard } from './-components/DormancyCard';
import { GovernanceScoreCard } from './-components/GovernanceScoreCard';
import { MonthlyUsageCard } from './-components/MonthlyUsageCard';
import { NewlyDetectedCard } from './-components/NewlyDetectedCard';
import { ShadowDetectionCard } from './-components/ShadowDetectionCard';
import { ShadowTrendCard } from './-components/ShadowTrendCard';
export const Route = createFileRoute('/_staff/accesses/_layout/overview/')({
  component: AccessesOverview
});
export function AccessesOverview() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.accesses'
  });
  useDocumentTitle(t('productHeader.pageTitle'));
  const {
    data: memberCountData
  } = useActiveMemberCount();
  const {
    data: trendData
  } = useOverviewShadowDetection();
  const {
    data: dormancyData
  } = useDormantSummary();
  const {
    data: usageData
  } = useAlertsSummary();
  const {
    data: shadowServices
  } = useShadowServices({
    page: 1,
    pageSize: 5,
    orderBy: 'ACCESS_COUNT_30DAYS',
    orderDirection: 'desc'
  });
  return <VStack className="gap-6 px-12 py-5">
      {/* Row 1: 検知系サマリ（行内は等高 stretch。Dormancy をコンパクト化して全体を低く） */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        <ShadowDetectionCard data={trendData} />
        <DormancyCard data={dormancyData} />
        <MonthlyUsageCard data={usageData} totalMembers={memberCountData?.ALL_ACTIVE} />
      </div>

      {/* Row 2: 推移・新規検知（半々で配置） */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <ShadowTrendCard data={trendData} />
        <NewlyDetectedCard items={shadowServices?.items ?? []} />
      </div>

      {/* アクセス統制スコア（Coming soon） */}
      <GovernanceScoreCard />
    </VStack>;
}